import React, { useState, useEffect } from "react";
import useToast from "@shared/hooks/useToast";
import "./Toast.scss";

const Toast = ({ message, id, color, timeOut = 2000 }) => {
    const { clearToast } = useToast();
    const [isFading, setIsFading] = useState(false);

    useEffect(() => {
        if (!timeOut || Number(timeOut) <= 0) return undefined;
        const timer = setTimeout(() => {
            handleClose();
        }, timeOut);

        return () => clearTimeout(timer);
    }, [timeOut]);

    const handleClose = () => {
        setIsFading(true);
        setTimeout(() => clearToast(id), 500);
    };
    return (
        <div className={`Toast ${color} ${isFading ? "fadeOut" : ""}`} >
            <span>{message}</span>
            <button className="close-button" onClick={handleClose}>
                <i className="bi bi-x-circle-fill" style={{ color: "#6e6e6e" }}></i>
            </button>
        </div>
    );
};

export default Toast;